/* eslint-disable no-case-declarations */
import { CityConfig } from "../../constants/action-constants/CityConfigActionConstants";

const initialState = {
  // get City Config
  // -----------------------------------------------------------------------
  cityConfig: {},
  cityConfigLoading: false,
  cityConfigError: "",

  // Upload city config
  // -----------------------------------------------------------------------
  uploadCityConfigLoading: false,
  uploadCityConfigError: "",

  // Download city config excel template
  // -----------------------------------------------------------------------
  downloadCityConfigExcelTemplateLoading: false,
  downloadCityConfigExcelTemplateError: "",
};

// construct config
function constructCityConfig(existingCityConfigs = {}, payload = {}) {
  const { cityConfig = {}, configType } = payload || {};
  const { items = [] } = cityConfig || {};

  // Start with existing state
  const constructedCityConfig = { ...existingCityConfigs };

  // Ensure configType exists
  if (!constructedCityConfig[configType]) {
    constructedCityConfig[configType] = {};
  }

  // Build mapping
  items.forEach((item) => {
    const { category, names = [] } = item;
    const categoryKey = category || ""; // Use empty string if category is undefined/null
    const namesArray = Array.isArray(names) ? names : []; // Ensure names is an array

    // Trim category (remove extra spaces : start or end)
    const trimmedCategory = categoryKey.trim();
    const trimmedNames = namesArray.map((name) => name.trim());

    constructedCityConfig[configType][trimmedCategory] = {
      label: trimmedCategory,
      types: trimmedNames,
    };
  });

  return constructedCityConfig;
}

export default (state = initialState, action) => {
  switch (action.type) {
    // get city config
    // -----------------------------------------------------------------------
    case CityConfig.GET_CITY_CONFIG:
      return {
        ...state,
        cityConfigLoading: true,
      };
    case CityConfig.GET_CITY_CONFIG_SUCCESS: {
      const constructedCityConfig = constructCityConfig(
        state.cityConfig,
        action.payload
      );

      return {
        ...state,
        cityConfigLoading: false,
        cityConfig: constructedCityConfig,
      };
    }
    case CityConfig.GET_CITY_CONFIG_FAILURE:
      return {
        ...state,
        cityConfigLoading: false,
        cityConfigError: action.payload,
      };

    // upload city config
    // -----------------------------------------------------------------------
    case CityConfig.UPLOAD_CITY_CONFIG:
      return {
        ...state,
        uploadCityConfigLoading: true,
      };
    case CityConfig.UPLOAD_CITY_CONFIG_SUCCESS: {
      return {
        ...state,
        uploadCityConfigLoading: false,
      };
    }
    case CityConfig.UPLOAD_CITY_CONFIG_FAILURE:
      return {
        ...state,
        uploadCityConfigLoading: false,
        uploadCityConfigError: action.payload,
      };

    // Download city config excel template
    // -----------------------------------------------------------------------
    case CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE:
      return {
        ...state,
        downloadCityConfigExcelTemplateLoading: true,
      };
    case CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_SUCCESS: {
      return {
        ...state,
        downloadCityConfigExcelTemplateLoading: false,
      };
    }
    case CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadCityConfigExcelTemplateLoading: false,
        downloadCityConfigExcelTemplateError: action.payload,
      };

    // clear
    case CityConfig.CLEAR_CITY_CONFIG: {
      return {
        ...state,
        cityConfig: {},
      };
    }

    default:
      return state;
  }
};
